/**
 * A shell alert's `target_link` may carry a query string
 * (`/admin/settings?section=inventory-rollout`). TanStack's `Link` wants the
 * path in `to` and the query as a `search` object, so split it here — one
 * place for the banner and the alert center.
 */
export function splitTargetLink(link: string): {
  to: string
  search?: Record<string, string>
} {
  const at = link.indexOf('?')
  if (at < 0) return { to: link }
  const search: Record<string, string> = {}
  for (const [key, value] of new URLSearchParams(link.slice(at + 1))) search[key] = value
  return Object.keys(search).length > 0 ? { to: link.slice(0, at), search } : { to: link.slice(0, at) }
}
